import React from 'react';

import { ReactComponent as Arrow } from '../../../../images/icons/fs-lc-arrow.svg';
import SmartLink from '../../../Common/SmartLink';
import * as styles from './DesktopMenu.module.scss';
import ListItem from './ListItem';

export default function DesktopMenu({ menuItems }) {
  return (
    <ul className={styles.desktopMenu} data-analytics-component={'desktop-menu'}>
      {menuItems.map((item, i) => (
        <li
          data-analytics-component={'desktop-menu-item'}
          data-analytics-id={item.title}
          className={styles.primaryItem}
          key={`${item.title}-${i}`}
        >
          {item.url ? (
            <SmartLink to={item.url} data-analytics-link={item.title}>
              {item.title}
            </SmartLink>
          ) : (
            item.title
          )}
          {item.subItems && (
            <div className={styles.submenu}>
              <div className={styles.columns} style={{ gridTemplateColumns: `repeat(${item.subItems.length}, 1fr)` }}>
                {item.subItems.map((subItem, j) => (
                  <ul
                    key={`${subItem.title}-${j}`}
                    className={[styles.submenuList, subItem.colorTheme ? styles[subItem.colorTheme] : ''].join(' ')}
                  >
                    <ListItem styles={styles} item={subItem} isTitle={true} />
                    {subItem.subItems &&
                      subItem.subItems.map((sub, k) => (
                        <ListItem styles={styles} item={sub} key={`${sub.title}-${k}`} />
                      ))}
                    {subItem.cta && <ListItem styles={styles} item={subItem.cta} isCta={true} />}
                  </ul>
                ))}
              </div>
              {item.callouts && (
                <div>
                  <div
                    className={styles.callouts}
                    style={{ gridTemplateColumns: `repeat(${item.callouts.length}, 1fr)` }}
                  >
                    {item.callouts.map((callout, c) => (
                      <SmartLink
                        key={`callout-${c}`}
                        to={callout.url}
                        className={[styles.callout, callout.colorTheme ? styles[callout.colorTheme] : ''].join(' ')}
                        data-analytics-component={'desktop-menu-callout'}
                        data-analytics-id={callout.title}
                      >
                        {callout.imageSrc && <img loading="lazy" src={callout.imageSrc} alt={callout.title} />}
                        <div className={styles.calloutTitle}>
                          <span>{callout.title}</span> <Arrow className={styles.arrow} />
                        </div>
                        <div className={styles.calloutDescription}>{callout.description}</div>
                      </SmartLink>
                    ))}
                  </div>
                </div>
              )}
            </div>
          )}
        </li>
      ))}
    </ul>
  );
}
